import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c917e95")

_pushScopeId("data-v-6c917e95")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("深度数据")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部清空")
const _hoisted_4 = { class: "no-wrap" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { style: {"cursor":"pointer","color":"#61c3e4"} }, "下载", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_form, {
                  class: "spacForm",
                  size: "mini",
                  inline: true
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "选择日期" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.selected_table_date,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected_table_date = $event)),
                          placeholder: "请选择日期",
                          clearable: "",
                          filterable: "",
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTableChange('Search')))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.date_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "选择场景" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.selected_table_scene,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selected_table_scene = $event)),
                          placeholder: "请选择场景",
                          clearable: "",
                          filterable: "",
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectTableChange('Search')))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.scene_id,
                                label: item.chinese,
                                value: item.scene_id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "选择机型" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.selected_table_device,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selected_table_device = $event)),
                          placeholder: "请选择机型",
                          clearable: "",
                          filterable: "",
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectTableChange('Search')))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (group) => {
                              return (_openBlock(), _createBlock(_component_el_option_group, {
                                key: group.label,
                                label: group.label
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.label
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "选择版本" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.selected_table_version,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selected_table_version = $event)),
                          placeholder: "请选择版本",
                          clearable: "",
                          filterable: "",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectTableChange('Search')))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.report_type.length != 1)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "报告类型"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              style: {"width":"130px"},
                              modelValue: _ctx.ruleForm.report_type,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.ruleForm.report_type = $event)),
                              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectTableChange('Search', true)))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_type, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.report_type.length != 1)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          label: "子类型"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.ruleForm.sub_type,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.ruleForm.sub_type = $event)),
                              placeholder: "请选择版本",
                              clearable: "",
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectTableChange('Search')))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subList, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: _ctx.deep_type,
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.deepBtn('Search')))
                        }, {
                          default: _withId(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }, 8, ["type"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onTableClear()))
                        }, {
                          default: _withId(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_card, null, {
                  default: _withId(() => [
                    _withDirectives(_createVNode(_component_el_table, {
                      fit: "false",
                      data: _ctx.sumMary_data.results,
                      ref: "dataTable",
                      "header-cell-class-name": "tabelHeader"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          type: "index",
                          label: "序号",
                          width: "60",
                          fixed: "left"
                        }, {
                          default: _withId((scope) => [
                            _createVNode(_component_el_tooltip, {
                              class: "item",
                              effect: "dark",
                              placement: "top-start"
                            }, {
                              content: _withId(() => [
                                _createTextVNode(" id_test:" + _toDisplayString(scope.row.id_test), 1)
                              ]),
                              default: _withId(() => [
                                _createVNode("span", null, _toDisplayString(_ctx.indexMethod(scope.$index)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          fixed: "left",
                          width: "350",
                          label: "日期版本"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(_ctx.formatDate(scope.row.timestamp) +
                    " " +
                    scope.row.game_version), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          fixed: "left",
                          width: "150",
                          label: "机型"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.device_id.model.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          fixed: "left",
                          width: "300",
                          label: "场景"
                        }, {
                          default: _withId((scope) => [
                            _createVNode("div", _hoisted_4, _toDisplayString(scope.row.scene_id.chinese), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.report_type.length != 1)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              width: "180",
                              label: "报告类型"
                            }, {
                              default: _withId((scope) => [
                                _createTextVNode(_toDisplayString(_ctx.test_type[scope.row.type] +
                    "-" +
                    _ctx.test_sub_type[scope.row.subtype]), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_table_column, { label: "类型" }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.is_auto ? "自动" : "手动"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "操作" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, { label: "数据详情" }, {
                              default: _withId((scope) => [
                                _createVNode("a", {
                                  target: "_blank",
                                  href: _ctx.get_url(scope.row.url),
                                  style: {"cursor":"pointer","color":"#61c3e4","text-decoration":"underline"}
                                }, "查看", 8, ["href"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "CPU分析" }, {
                              default: _withId((scope) => [
                                (_ctx.statusShow(scope.row.status)[2])
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.see(scope.row)),
                                      style: {"cursor":"pointer","color":"#61c3e4","text-decoration":"underline"}
                                    }, "查看", 8, ["onClick"]))
                                  : (scope.row.status == 4)
                                    ? (_openBlock(), _createBlock("span", {
                                        key: 1,
                                        onClick: ($event: any) => (_ctx.retry(scope.row.cpu_id)),
                                        style: {"cursor":"pointer","color":"#61c3e4","text-decoration":"underline"}
                                      }, "重试", 8, ["onClick"]))
                                    : (scope.row.status != 4 && scope.row.status != 5)
                                      ? (_openBlock(), _createBlock("span", {
                                          key: 2,
                                          style: 'color:' + _ctx.statusShow(scope.row.status)[1]
                                        }, _toDisplayString(_ctx.statusShow(scope.row.status)[0]), 5))
                                      : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "函数耗时" }, {
                              default: _withId((scope) => [
                                (_ctx.statusShow(scope.row.status)[2])
                                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                                      key: 0,
                                      "confirm-button-text": "是",
                                      "cancel-button-text": "否",
                                      icon: "el-icon-info",
                                      title: "因数据量较大，离线文件可能存在加载较慢或失败的现象，请多尝试几次，如问题一直存在可反馈至平台.\n  确认要下载这个文件吗？",
                                      placement: "top",
                                      onConfirm: ($event: any) => (_ctx.downloadFile(scope.row.cpu_html))
                                    }, {
                                      reference: _withId(() => [
                                        _hoisted_5
                                      ]),
                                      _: 2
                                    }, 1032, ["onConfirm"]))
                                  : (_openBlock(), _createBlock("span", {
                                      key: 1,
                                      style: 'color:' + _ctx.statusShow(scope.row.status)[1]
                                    }, _toDisplayString(_ctx.statusShow(scope.row.status)[0]), 5))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "FPS" }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.avg_fps), 1)
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subType, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_table_column, {
                            key: index,
                            label: item.label
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.sub, (v, i) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  width: _ctx.titleWidth(v.lable),
                                  label: v.lable,
                                  key: i
                                }, {
                                  default: _withId((scope) => [
                                    _createTextVNode(_toDisplayString(scope.row[v.value]), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["width", "label"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128)),
                        _createVNode(_component_el_table_column, {
                          width: "160",
                          label: "Peak Memory(MB)"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.max_pss), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "温度(°C)" }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.cpu_temp), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "备注" }, {
                          default: _withId((scope) => [
                            (scope.row.flag)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  style: {"display":"inline-block","width":"100%"},
                                  onDblclick: ($event: any) => (_ctx.edit(scope.row))
                                }, _toDisplayString(scope.row.remark ? scope.row.remark : "-"), 41, ["onDblclick"]))
                              : (_openBlock(), _createBlock(_component_el_input, {
                                  key: 1,
                                  size: "mini",
                                  style: {"width":"100%"},
                                  onBlur: ($event: any) => (_ctx.edit_input(scope.row)),
                                  modelValue: scope.row.remark,
                                  "onUpdate:modelValue": ($event: any) => (scope.row.remark = $event)
                                }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue"]))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "pagingStyle"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "每页" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.record,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.record = $event)),
                              style: {"width":"50px"},
                              onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectTableChange('paging')))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "条记录" }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_pagination, {
                              onCurrentChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.selectTableChange('paging'))),
                              currentPage: _ctx.current_page,
                              "onUpdate:currentPage": _cache[18] || (_cache[18] = ($event: any) => (_ctx.current_page = $event)),
                              "page-size": _ctx.record,
                              layout: "total, prev, pager, next, jumper",
                              total: _ctx.sumMary_data.count
                            }, null, 8, ["currentPage", "page-size", "total"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})